define([
	"dojo/_base/declare",
	"csi/heading/Number"
], function(declare,NumberRen) {

	return declare(NumberRen, {
		_isFraction: function(/*Context*/ctx) {
			// summary: not used by default, but can be used explicitly in View XML to show numbers as fractions
			return true;
		}
	});
});